import { fetchAutomationList, fetchJsonSchema } from '../automation/automation_common_func';

type AutomationLogProps = {
    dartNo: number;
    remediationObj: any;
    setJsonData: any;
    setUiData: any;
    setSelectedOptions: any;
    setOldSelectedOptions: any;
}

const Automation_activity_log_func = (props: AutomationLogProps) => {
    const getAutomationList = async (whereCondition: object, limit: number | null = null, offset: number | null = null) => {
        try {
            const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

            if (status === 'success' && data.length > 0) {
                var subAutomationNames: string[] = [];
                var oldSubAutomationNames: string[] = [];
                var subAutoamtionDataObj: any = {};

                data.map((val: any) => {
                    if (props?.remediationObj?.old_automation_sequence?.includes(val.id)) {
                        oldSubAutomationNames.push(val.automationName);
                    }

                    if (props?.remediationObj?.automation_sequence?.includes(val.id)) {
                        subAutomationNames.push(val.automationName);
                        subAutoamtionDataObj[`${val.automationName}`] = val.id;
                    }
                });

                props.setSelectedOptions(subAutomationNames);
                props.setOldSelectedOptions(oldSubAutomationNames);
            } else {
                props.setSelectedOptions([]);
                props.setOldSelectedOptions([]);
            }
        } catch (error) {
            console.log("getAutomationList error=", error);
            props.setSelectedOptions([]);
            props.setOldSelectedOptions([]);
        }
    }

    const getJsonSchema = async (dartid: number) => {
        try {
            const { data, status } = await fetchJsonSchema(dartid);

            if (status === 'success' && data.length > 0) {
                const jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
                const uiSchema = JSON.parse(data[0]?.uiSchema);
                uiSchema["ui:submitButtonOptions"] = {
                    "norender": true,
                };

                data[0]?.jsonSchema !== undefined && props.setJsonData(jsonSchemaData);
                data[0]?.uiSchema !== undefined && props.setUiData(uiSchema);
            } else {
                props.setJsonData({});
                props.setUiData({});
            }
        } catch (error) {
            console.log("getJsonSchema error=", error);
            props.setJsonData({});
            props.setUiData({});
        }
    }

    if (props.remediationObj.type === 'selfhelp') {
        console.log("props?.remediationObj=", props?.remediationObj);
        const oldIds = props?.remediationObj?.old_automation_sequence?.split(",").map(Number);
        const newIds = props?.remediationObj?.automation_sequence?.split(",").map(Number);

        getAutomationList({ 'types': "automation", id: { _in: oldIds.concat(newIds) } }, null, null);
    }

    props.dartNo !== 0 && getJsonSchema(props.dartNo);
}

export { Automation_activity_log_func }